var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagPortugal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9999C0 22.8793 4.342 28.744 10.4347 31.0047L11.8261 15.9999L10.4347 0.995117C4.342 3.25587 0 9.12049 0 15.9999Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.1635 24.8365 0 16 0C14.0429 0 12.1681 0.352063 10.4347 0.995188V31.0048C12.1681 31.648 14.0429 32 16 32C24.8365 32 32 24.8365 32 16Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4343 21.5652C13.5079 21.5652 15.9995 19.0736 15.9995 16C15.9995 12.9264 13.5079 10.4348 10.4343 10.4348C7.36076 10.4348 4.86914 12.9264 4.86914 16C4.86914 19.0736 7.36076 21.5652 10.4343 21.5652Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30469 13.2173V16.6955C7.30469 18.4244 8.70619 19.826 10.4351 19.826C12.1641 19.826 13.5656 18.4245 13.5656 16.6955V13.2173H7.30469Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4351 17.7392C9.85973 17.7392 9.3916 17.2711 9.3916 16.6957V15.3044H11.4785V16.6958C11.4785 17.2711 11.0104 17.7392 10.4351 17.7392Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPortugal);
export default __webpack_public_path__ + "static/media/flag_portugal.1acb9756812ec11ed357cbe7e3dbda3a.svg";
export { ForwardRef as ReactComponent };